import { debounce, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { AttributesMixin, define, type } from "@type-r/models";
import { FilterModel } from "lqx-react/lib";
import * as React from 'react';
import { useEffect, useState } from "react";
export interface MultiSelectChipsAsyncFilter extends AttributesMixin<typeof MultiSelectChipsAsyncFilter> { }
@define
export class MultiSelectChipsAsyncFilter extends FilterModel {
    static attributes = {
        ...FilterModel.attributes,
        options: [String],
        selected: type([String]).required,
        placeholder: type(String).null,
        isDone: type(Boolean).check(function (x) { return x && this.selected && this.selected.length; }),
        getItems: Function
    }

    delete() {
        this.$.selected.set(undefined);
        this.$.isDone.set(false);
    }

    asLabel() {
        return this.selected.length > 1 ? `Selected ${this.selected.length}` : this.selected[0];
    }

    asTitle() {
        return this.selected.map(x => x).join();
    }
}

export const EnterMultiSelectChipsAsync = ({ filterName, onEnter, filterValue }: { filterName: any, onEnter: any, filterValue: MultiSelectChipsAsyncFilter }) => {
    const [options, setOptions] = useState([]);
    const [open, setOpen] = useState(false);
    const loading = open && options.length === 0;

    const getLoadOptions = async (query, callback) => {
        const response = await filterValue.getItems(query);
        callback(response.items || response);
    };
    const loadOptions = debounce(getLoadOptions, 300);

    useEffect(() => {
        let active = true;

        if (!loading) {
            return undefined;
        }

        (async () => {
            if (active) {
                await getLoadOptions('', setOptions);
            }
        })();

        return () => {
            active = false;
        };
    }, [loading]);

    useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    return (
        <Autocomplete
            multiple
            id="connections-companies"
            size="small"
            options={options}
            loading={loading}
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            filterOptions={(x) => filterName == "company"
                ? x.filter(x => !filterValue.$.selected.value.some(selected => selected === x.id))
                : x.filter(x => !filterValue.$.selected.value.some(selected => selected === x.name))}
            getOptionLabel={(option) => option.name || option.value}
            filterSelectedOptions
            style={{ width: "500px", margin: "4px 4px 4px 0", border: '1px solid #c4c4c4', borderRadius: "4px" }}
            onChange={(_, items: any) => {
                setOptions(items ? [items, ...options] : options);
                filterValue.$.selected.set(items.map(x => filterName == "company" ? x.id : x.name));
                onEnter(filterValue.clone());
            }}
            onInputChange={(_, newInputValue) => {
                loadOptions(newInputValue, setOptions);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    color="secondary"
                    placeholder={filterValue.$.placeholder.value}
                    style={{ border: 'none' }}
                    className={filterValue.selected.length ? "" : "error"}
                />
            )}
        />
    );
}
